import type { StaticImageData } from 'next/image';

import { NumberStack } from '@rumblefish/ui/Rumblefish23Theme';

import karolinaPhoto from '../../../public/webp/fromPNG/team/Karolina.webp';
import marcinPhoto from '../../../public/webp/fromPNG/team/Marcin.webp';
import marekPhoto from '../../../public/webp/fromPNG/team/Marek.webp';
import sylwiaPhoto from '../../../public/webp/fromPNG/team/Sylwia.webp';
import {
  StyledAccentBar,
  StyledAvatar,
  StyledAvatarStack,
  StyledContent,
  StyledCountersWrapper,
  StyledGlow,
  StyledHeader,
  StyledHeading,
  StyledIntro,
  StyledTeamBanner,
  StyledTeamBannerLink,
  StyledTeamDescription,
  StyledTeamHeading,
  StyledTeamLink,
  StyledTeamTextGroup,
  WhoWeAreSection,
} from './styles';
import { whoWeAreData } from './whoWeAre.data';
import type { WhoWeAreProps } from './WhoWeAre.types';

const teamAvatars = [
  { src: marekPhoto, name: 'Marek' },
  { src: marcinPhoto, name: 'Marcin' },
  { src: sylwiaPhoto, name: 'Sylwia' },
  { src: karolinaPhoto, name: 'Karolina' },
];

export const WhoWeAre = ({ ...props }: WhoWeAreProps) => {
  return (
    <WhoWeAreSection width="normal">
      <StyledContent {...props}>
        <StyledHeader>
          <StyledHeading variant="h2">Who we are</StyledHeading>
          <StyledAccentBar />
        </StyledHeader>

        <StyledIntro>{whoWeAreData.intro}</StyledIntro>

        <StyledTeamBannerLink
          to={whoWeAreData.teamTeaser.linkHref}
          label={whoWeAreData.teamTeaser.heading}>
          <StyledTeamBanner
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}>
            <StyledGlow />

            <StyledAvatarStack>
              {teamAvatars.map((avatar) => (
                <StyledAvatar
                  key={avatar.name}
                  src={(avatar.src as unknown as StaticImageData)?.src}
                  alt={avatar.name}
                />
              ))}
            </StyledAvatarStack>

            <StyledTeamTextGroup>
              <StyledTeamHeading>
                {whoWeAreData.teamTeaser.heading}
              </StyledTeamHeading>
              <StyledTeamDescription>
                {whoWeAreData.teamTeaser.description}
              </StyledTeamDescription>
            </StyledTeamTextGroup>

            <StyledTeamLink>
              {whoWeAreData.teamTeaser.linkText} →
            </StyledTeamLink>
          </StyledTeamBanner>
        </StyledTeamBannerLink>

        <StyledCountersWrapper
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}>
          <NumberStack counters={whoWeAreData.counters} />
        </StyledCountersWrapper>
      </StyledContent>
    </WhoWeAreSection>
  );
};
